export const approvalDropdownItems =
[
  {
    key: 'permited',
    value: 'Allow'
  },
  {
    key: 'restricted',
    value: 'Lock'
  },
  {
    key: 'under_request',
    value: 'Admin Approval'
  }
];

export const restrictionTypes = ['tight', 'loose'];

export const icons = {
  logo: '#editor-my-assets',
  icon: '#heart',
  text: '#editor-text',
  image: '#editor-images',
  vector: '#editor-elements',
  shape: '#editor-elements',
  video: '#editor-video',
  table: '#editor-table',
  background: '#editor-images',
  sticker: '#editor-elements',
  qrcode: '#qr-code'
};

export const swearingFilters = [
  { id: 'en', name: 'English' },
  { id: 'es', name: 'español' },
  { id: 'ru', name: 'Русский' },
  { id: 'pt', name: 'português' },
  { id: 'de', name: 'Deutsch' },
  { id: 'nl', name: 'Nederlands' },
  { id: 'fr', name: 'français' },
  { id: 'it', name: 'Italiano' }
];

export const dateFormat = [
  'DD/MM/YY',
  'LL',
  'DD-MM-YYYY',
  'MM/DD/YYYY',
  'YYYY-MM-DD',
  'YY-MM-DD'
];

export const actionsList = [
  'function_print_file',
  'function_share_file',
  'function_download_file',
  'function_animation_file',
  'function_change_layer_order'
];

export const requestActionsList = [
  'function_request_print_file',
  'function_request_share_file',
  'function_request_download_file'
];

export const sectionInitialHeight = 0;

export const elementRestrictionsItemMargin = 10;

export const templateRestrictionsContainerMargin = 20;

export const colorPickerMargin = 16;
